"use strict";
/**
 * @license
 * Copyright 2016 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export function simpleStringHash(s) {
  let h = 0;
  const length = s.length;
  for (let i = 0; i < length; ++i) {
    h = h * 31 + s.charCodeAt(i) | 0;
  }
  return h;
}
export function murmurHash3_x86_32Mix(h, k) {
  k = Math.imul(k, 3432918353) >>> 0;
  k = (k << 15 | k >>> 17) >>> 0;
  k = Math.imul(k, 461845907) >>> 0;
  h ^= k;
  h = (h << 13 | h >>> 19) >>> 0;
  h = Math.imul(h, 5) + 3864292196 >>> 0;
  return h;
}
export function murmurHash3_x86_32Finalize(h, len) {
  h ^= len;
  h ^= h >>> 16;
  h = Math.imul(h, 2246822507) >>> 0;
  h ^= h >>> 13;
  h *= 3266489909;
  h ^= h >>> 16;
  return h >>> 0;
}
export function murmurHash3_x86_32Hash64Bits(seed, low, high) {
  let h = seed;
  h = murmurHash3_x86_32Mix(h, low);
  h = murmurHash3_x86_32Mix(h, high);
  return murmurHash3_x86_32Finalize(h, 8);
}
export function murmurHash3_x86_32Hash64Bits_Bigint(seed, x) {
  let h = seed;
  h = murmurHash3_x86_32Mix(h, Number(x & 0xffffffffn));
  h = murmurHash3_x86_32Mix(h, Number(x >> 32n));
  return murmurHash3_x86_32Finalize(h, 8);
}
function murmurHash3_x86_128Mix(h) {
  h ^= h >>> 16;
  h = Math.imul(h, 2246822507);
  h ^= h >>> 13;
  h = Math.imul(h, 3266489909);
  h ^= h >>> 16;
  return h;
}
function rotl32(x, r) {
  return x << r | x >>> 32 - r;
}
export function murmurHash3_x86_128Hash64Bits_Bigint(seed, input) {
  let h1 = seed;
  let h2 = seed;
  let h3 = seed;
  let h4 = seed;
  const c1 = 597399067;
  const c2 = 2869860233;
  const c3 = 951274213;
  let k2 = Math.imul(Number(input >> BigInt(32)), c2);
  k2 = rotl32(k2, 16);
  k2 = Math.imul(k2, c3);
  h2 ^= k2;
  let k1 = Math.imul(Number(input & BigInt(4294967295)), c1);
  k1 = rotl32(k1, 15);
  k1 = Math.imul(k1, c2);
  h1 ^= k1;
  const len = 8;
  h1 ^= len;
  h2 ^= len;
  h3 ^= len;
  h4 ^= len;
  h1 = h1 + h2 >>> 0;
  h1 = h1 + h3 >>> 0;
  h1 = h1 + h4 >>> 0;
  h2 = h2 + h1 >>> 0;
  h3 = h3 + h1 >>> 0;
  h4 = h4 + h1 >>> 0;
  h1 = murmurHash3_x86_128Mix(h1);
  h2 = murmurHash3_x86_128Mix(h2);
  h3 = murmurHash3_x86_128Mix(h3);
  h4 = murmurHash3_x86_128Mix(h4);
  h1 = h1 + h2 >>> 0;
  h1 = h1 + h3 >>> 0;
  h1 = h1 + h4 >>> 0;
  h2 = h2 + h1 >>> 0;
  return BigInt(h1) | BigInt(h2) << BigInt(32);
}
